import React from 'react';
import { Button } from '@farmers-fridge/ui-library';
import FFLinkButton from '../../components/buttons/FFLinkButton';
import makeContentfulSectionIdAttr from '../../utils/makeContentfulSectionIdAttr';
import { getIcon } from './iconMap';
import styles from './CTA.module.css';
import useModal from '../../utils/useModal';
// eslint-disable-next-line import/no-cycle
import SignUpModal from '../../components/branding/SignUpModal';

/**
 * @param {object} props
 * @param {{ contentful_id: string}=} props.anchorLink
 * @param {string=} props.contentful_id
 * @param {("primary"|"secondary"|"tertiary")} props.buttonType
 * @param {boolean=} props.isInline
 * @param {string} props.text
 * @param {string=} props.url
 * @param {{ name: string}=} props.icon
 * @param {string=} props.iconPosition
 * @param {object} props.modal
 * @param {string=} props.modal.headline
 * @param {string=} props.modal.emailPlaceholder
 * @param {string=} props.modal.phonePlacholder
 * @param {string=} props.modal.buttonCta
 * @param {object} props.modal.image
 * @param {string=} props.modal.image.description
 * @param {import('gatsby-plugin-image').IGatsbyImageData=} props.modal.image.gatsbyImageData
 * @param {import('gatsby-source-contentful/rich-text.d').RenderRichTextData<import('gatsby-source-contentful/rich-text.d').ContentfulRichTextGatsbyReference>} props.modal.helpText
 * @param {import('gatsby-source-contentful/rich-text.d').RenderRichTextData<import('gatsby-source-contentful/rich-text.d').ContentfulRichTextGatsbyReference>} props.modal.confirmationText
 * @param {string} props.modal.contentful_id
 */
function CallToActionButton({
  anchorLink,
  contentful_id: contentfulId,
  buttonType,
  isInline,
  text,
  url,
  icon,
  iconPosition,
  modal,
}) {
  let linkTo;
  if (anchorLink) {
    linkTo = `#${makeContentfulSectionIdAttr(anchorLink.contentful_id)}`;
  } else if (url) {
    linkTo = url;
  } else if (!modal) {
    throw new Error(
      `CTA with id "${contentfulId}" is missing valid link. "url" or "anchorLink" field is needed`,
    );
  }

  const [isShowing, toggle] = useModal();
  return (
    <>
      {linkTo && (
        <FFLinkButton
          className={`${isInline ? styles.inlineButton : styles.button} ${
            iconPosition === 'Right' ? styles.positionRight : ''
          }`}
          buttonType={buttonType}
          href={linkTo}
          onClick={toggle}
        >
          {buttonType !== 'tertiary' && getIcon(icon?.name)}
          {text}
        </FFLinkButton>
      )}
      {modal && (
        <Button
          buttonType={buttonType}
          className={`${isInline ? styles.inlineButton : styles.button} ${
            iconPosition === 'Right' ? styles.positionRight : ''
          }`}
          onClick={toggle}
        >
          {getIcon(icon?.name)}
          {modal.buttonCta}
        </Button>
      )}
      {isShowing && <SignUpModal data={modal} toggle={toggle} />}
    </>
  );
}

export default CallToActionButton;
